import React from 'react'
import { Card } from 'reactstrap'
import styles from './CardWCheckbox.styles'
import Checkbox from '../../checkbox/basecheckbox/Checkbox'

export default function CardWCheckbox({
    isSelected = false,
    isHighlighted = true,
    onChangeCb = () => { },
    onCardClickCb = () => { },
    children = null,
    containerStyle = {}
}) {

    const isHighlightedStyle = isHighlighted ? styles.highlighted : {};
    return (
        <>
            <Card style={{ ...styles.container, ...isHighlightedStyle, ...containerStyle }} onClick={(e) => {
                if (e.target.type !== "checkbox") onCardClickCb(e)
            }} >
                <Checkbox checked={isSelected} onChangeCb={onChangeCb} />

                {children}
            </Card >
        </>
    )
}
